<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.group_practice_periods', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <GroupPracticesForm
            :group-practice="groupPractice"
            :options="options"
            :meta="meta"
            :url="meta.links.update"
            is-edit
        />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GroupPracticesForm from './partials/GroupPracticesForm.vue';

export default {
    components: {
        PanelPage,
        GroupPracticesForm,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'options', 'groupPractice'],
};
</script>
